var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { asThemeConsumer } from "../../../theme/Theme";
import { ensure } from "../../../utils/Optional";
import { Label } from "../../../components/core/05-atoms/Label";
/**
 *
 * @param props
 */
var RadioBtnComp = /** @class */ (function (_super) {
    __extends(RadioBtnComp, _super);
    /**
     *
     * @param props
     */
    function RadioBtnComp(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { checked: _this.props.checked };
        _this.onChange = _this.onChange.bind(_this);
        return _this;
    }
    /**
     *
     */
    RadioBtnComp.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.checked !== this.props.checked) {
            this.setState({
                checked: this.props.checked,
            });
        }
    };
    RadioBtnComp.prototype.render = function () {
        var _a;
        var inputRadiobtn = (React.createElement("input", { style: this.props.style, className: "scl-a-checkbox__field", type: "radio", value: this.props.value || "", onChange: this.onChange, checked: (_a = this.state.checked) !== null && _a !== void 0 ? _a : false, disabled: this.props.disabled, name: this.props.name, id: this.props.id }));
        return ((React.createElement("div", { className: "scl-a-checkbox__wrapper" }, !!this.props.label ? (React.createElement(Label, null,
            inputRadiobtn,
            " ",
            React.createElement("span", null, this.props.label))) :
            inputRadiobtn)));
    };
    RadioBtnComp.prototype.onChange = function (evt) {
        ensure(this.props.onChange)(evt.target.value || undefined);
    };
    return RadioBtnComp;
}(React.Component));
export { RadioBtnComp };
/**
 *
 */
export var RadioBtn = asThemeConsumer(RadioBtnComp);
